/**
 * Change styles to owl case studies.
 */
 function owl_case_studies(){
    const elements = document.querySelectorAll(".owl-case-studies-container");  
   if (elements.length) {
        elements.forEach(function (element) {
            $(element).owlCarousel({
                rewind: true,
                autoplay: true,
                autoplaySpeed: 500,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    530: {
                        items: 2
                    },
                    1025: {
                        items: 3
                    }
                }
            });
        });
    }
}

owl_case_studies();

export default owl_case_studies;